import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function ContentTypeFormatter({ info }) {
  const { value, row } = getInfo(info)

  if (row.meta?.files) {
    return 'N/A'
  }

  return value
}
